/** Proposed AIM Goal wire contract; verify against the deployed service. */
export interface GoalResource {
  goalId: number;
  clientId: number;
  goalLevelCode: string;
  description: string;
  originalDescription: string | null;
  statusCode: string;
  caseIds: number[];
}

export interface GoalListPayload {
  items: GoalResource[];
  /** Observed development response on 2026-10-21; differs from AIM EDD v4. */
  resultSet: {
    count: number;
    limit: number;
    offset: number;
    allFetched: boolean;
  };
}

export interface QueryGoalsRequest {
  clientId: number;
  statusCode?: string;
  goalLevelCode?: string;
  caseId?: number;
  limit?: number;
  offset?: number;
}

/** API enum key for the Client level; database constant_name is not the wire value. */
export const CLIENT_GOAL_LEVEL_CODE = 'CLIENT';

export interface CreateGoalRequest {
  clientId: number;
  description: string;
  goalLevelCode: string;
  caseId?: number;
}

export interface UpdateGoalRequest {
  description?: string;
  statusCode?: 'COMPLETED' | 'NO_LONGER_RELEVANT';
  expectedCurrentStatusCode?: string;
}
